"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const productSubtypes_1 = require("../../../utils/productSubtypes");
const product_1 = require("../../../sharedTypings/product");
const __1 = require("../..");
const { AMOUNT, DETAILS, SUBTYPE, } = product_1.ProductField;
const { THC_MG, TOTAL_WEIGHT, } = product_1.ProductDetailsField;
const { BEVERAGE, CARTRIDGE, CBD, EDIBLE, EXTRACT, FLOWER, MERCH, MISC, NON_INV, PILL, PLANT, PREROLL, TINCTURE, TOPICAL, } = product_1.ProductType;
const { NULL, NUMBER, OBJECT, STRING, } = __1.JSONSchemaType;
const beverageRequirements = {
    if: {
        properties: { type: { "const": BEVERAGE } }
    },
    then: {
        properties: {
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG, TOTAL_WEIGHT],
            },
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.beverageSubtypes, null],
            }
        },
        required: [DETAILS]
    }
};
const cartridgeRequirements = {
    if: {
        properties: { type: { "const": CARTRIDGE } }
    },
    then: {
        properties: {
            details: {
                type: OBJECT,
                properties: {
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [TOTAL_WEIGHT],
            },
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.cartridgeSubtypes, null],
            }
        },
        required: [
            AMOUNT,
            product_1.ProductField.UOM,
        ],
    }
};
const cbdRequirements = {
    if: {
        properties: { type: { "const": CBD } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.cbdSubtypes, null],
            }
        },
    }
};
const edibleRequirements = {
    if: {
        properties: { type: { "const": EDIBLE } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.edibleSubtypes, null],
            },
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG, TOTAL_WEIGHT]
            }
        },
        required: [DETAILS]
    }
};
const extractRequirements = {
    if: {
        properties: { type: { "const": EXTRACT } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.extractSubtypes, null],
            },
            details: {
                type: OBJECT,
                properties: {
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [TOTAL_WEIGHT]
            }
        },
        required: [
            AMOUNT,
            DETAILS,
            product_1.ProductField.UOM,
        ]
    }
};
const BULK_FLOWER_SUBTYPES = productSubtypes_1.flowerSubtypes.filter(f => ['BULK FLOWER', 'SHAKE', 'STRAIN SPECIFIC SHAKE'].includes(f));
const flowerRequirements = {
    if: {
        properties: { type: { "const": FLOWER } }
    },
    then: {
        if: {
            properties: {
                type: { "const": FLOWER },
                subtype: { "enum": BULK_FLOWER_SUBTYPES }
            }
        },
        then: {
            properties: {
                subtype: {
                    type: STRING,
                    enum: BULK_FLOWER_SUBTYPES,
                }
            },
            required: [
                product_1.ProductField.UOM,
                SUBTYPE,
            ]
        },
        else: {
            not: {
                properties: {
                    subtype: { "enum": BULK_FLOWER_SUBTYPES },
                }
            },
            required: [
                AMOUNT,
                product_1.ProductField.UOM,
                SUBTYPE,
            ]
        }
    }
};
const merchRequirements = {
    if: {
        properties: { type: { "const": MERCH } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.merchSubtypes, null],
            },
        }
    }
};
const miscRequirements = {
    if: {
        properties: { type: { "const": MISC } }
    },
    then: {
        properties: {
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG]
            },
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.miscSubtypes, null],
            },
        },
        required: [DETAILS],
    }
};
const nonInvRequirements = {
    if: {
        properties: { type: { "const": NON_INV } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.nonInvSubtypes, null],
            },
        }
    }
};
const pillRequirements = {
    if: {
        properties: { type: { "const": PILL } }
    },
    then: {
        properties: {
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG, TOTAL_WEIGHT]
            },
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.pillSubtypes, null],
            },
        },
        required: [DETAILS]
    },
};
const plantRequirements = {
    if: {
        properties: { type: { "const": PLANT } },
    },
    then: {
        properties: {
            subtype: {
                type: STRING,
                enum: productSubtypes_1.plantSubtypes,
            }
        },
        required: [SUBTYPE]
    },
};
const defaultPrerollRequirements = {
    if: {
        properties: {
            type: { "const": PREROLL },
        },
        not: {
            properties: {
                subtype: { "enum": ["INFUSED", "SHAKE"] },
            }
        }
    },
    then: {
        properties: {
            subtype: {
                type: STRING,
                enum: productSubtypes_1.prerollSubtypes,
            },
            details: {
                type: OBJECT,
                properties: {
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [TOTAL_WEIGHT]
            },
        },
        required: [
            AMOUNT,
            DETAILS,
            product_1.ProductField.UOM,
            SUBTYPE,
        ]
    },
};
const infusedPrerollRequirements = {
    if: {
        properties: {
            subtype: { "const": "INFUSED" },
            type: { "const": PREROLL },
        },
    },
    then: {
        properties: {
            subtype: {
                type: STRING,
                enum: productSubtypes_1.prerollSubtypes,
            },
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG, TOTAL_WEIGHT]
            },
        },
        required: [
            AMOUNT,
            DETAILS,
            product_1.ProductField.UOM,
            SUBTYPE,
        ]
    },
};
const shakePrerollRequirements = {
    if: {
        properties: {
            subtype: { "const": "SHAKE" },
            type: { "const": PREROLL },
        },
    },
    then: {
        properties: {
            subtype: {
                type: STRING,
                enum: productSubtypes_1.prerollSubtypes,
            },
            details: {
                type: OBJECT,
                properties: {
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [TOTAL_WEIGHT]
            },
        },
        required: [
            DETAILS,
            product_1.ProductField.UOM,
            SUBTYPE,
        ]
    },
};
const prerollRequirements = [
    defaultPrerollRequirements,
    infusedPrerollRequirements,
    shakePrerollRequirements,
];
const tinctureRequirements = {
    if: {
        properties: { type: { "const": TINCTURE } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.tinctureSubtypes, null],
            },
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG, TOTAL_WEIGHT]
            },
        },
        required: [DETAILS]
    }
};
const topicalRequirements = {
    if: {
        properties: { type: { "const": TOPICAL } }
    },
    then: {
        properties: {
            subtype: {
                type: [STRING, NULL],
                enum: [...productSubtypes_1.topicalSubtypes, null],
            },
            details: {
                type: OBJECT,
                properties: {
                    [THC_MG]: {
                        minimum: 0,
                        type: NUMBER,
                    },
                    [TOTAL_WEIGHT]: {
                        exclusiveMinimum: 0,
                        type: NUMBER,
                    },
                },
                required: [THC_MG, TOTAL_WEIGHT]
            },
        },
        required: [DETAILS]
    }
};
const requirements = {
    allOf: [
        beverageRequirements,
        cartridgeRequirements,
        cbdRequirements,
        edibleRequirements,
        extractRequirements,
        flowerRequirements,
        merchRequirements,
        miscRequirements,
        nonInvRequirements,
        pillRequirements,
        plantRequirements,
        ...prerollRequirements,
        tinctureRequirements,
        topicalRequirements
    ]
};
exports.default = requirements;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQVouanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvanNvblNjaGVtYS9wcm9kdWN0cy9yZWdpb25TY2hlbWFzL0FaLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsb0VBZThFO0FBQzlFLDREQUk4RTtBQUM5RSw2QkFFcUQ7QUFFckQsTUFBTSxFQUNGLE1BQU0sRUFDTixPQUFPLEVBQ1AsT0FBTyxHQUNWLEdBQUcsc0JBQVksQ0FBQztBQUVqQixNQUFNLEVBQ0YsTUFBTSxFQUNOLFlBQVksR0FDZixHQUFHLDZCQUFtQixDQUFDO0FBRXhCLE1BQU0sRUFDRixRQUFRLEVBQ1IsU0FBUyxFQUNULEdBQUcsRUFDSCxNQUFNLEVBQ04sT0FBTyxFQUNQLE1BQU0sRUFDTixLQUFLLEVBQ0wsSUFBSSxFQUNKLE9BQU8sRUFDUCxJQUFJLEVBQ0osS0FBSyxFQUNMLE9BQU8sRUFDUCxRQUFRLEVBQ1IsT0FBTyxHQUNWLEdBQUcscUJBQVcsQ0FBQztBQUVoQixNQUFNLEVBQ0YsSUFBSSxFQUNKLE1BQU0sRUFDTixNQUFNLEVBQ04sTUFBTSxHQUNULEdBQUcsa0JBQWMsQ0FBQztBQUVuQixNQUFNLG9CQUFvQixHQUFHO0lBQ3pCLEVBQUUsRUFBRTtRQUNBLFVBQVUsRUFBRSxFQUFFLElBQUksRUFBRSxFQUFFLE9BQU8sRUFBRSxRQUFRLEVBQUUsRUFBRTtLQUM5QztJQUNELElBQUksRUFBRTtRQUNGLFVBQVUsRUFBRTtZQUNSLE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsTUFBTTtnQkFDWixVQUFVLEVBQUU7b0JBQ1IsQ0FBQyxNQUFNLENBQUMsRUFBRTt3QkFDTixPQUFPLEVBQUUsQ0FBQzt3QkFDVixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7b0JBQ0QsQ0FBQyxZQUFZLENBQUMsRUFBRTt3QkFDWixnQkFBZ0IsRUFBRSxDQUFDO3dCQUNuQixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7aUJBQ0o7Z0JBQ0QsUUFBUSxFQUFFLENBQUMsTUFBTSxFQUFFLFlBQVksQ0FBQzthQUNuQztZQUNELE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDO2dCQUNwQixJQUFJLEVBQUUsQ0FBQyxHQUFHLGtDQUFnQixFQUFFLElBQUksQ0FBQzthQUNwQztTQUNKO1FBQ0QsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO0tBQ3RCO0NBQ0osQ0FBQztBQUVGLE1BQU0scUJBQXFCLEdBQUc7SUFDMUIsRUFBRSxFQUFFO1FBQ0EsVUFBVSxFQUFFLEVBQUUsSUFBSSxFQUFFLEVBQUUsT0FBTyxFQUFFLFNBQVMsRUFBRSxFQUFFO0tBQy9DO0lBQ0QsSUFBSSxFQUFFO1FBQ0YsVUFBVSxFQUFFO1lBQ1IsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxNQUFNO2dCQUNaLFVBQVUsRUFBRTtvQkFDUixDQUFDLFlBQVksQ0FBQyxFQUFFO3dCQUNaLGdCQUFnQixFQUFFLENBQUM7d0JBQ25CLElBQUksRUFBYyxNQUFNO3FCQUMzQjtpQkFDSjtnQkFDRCxRQUFRLEVBQUUsQ0FBQyxZQUFZLENBQUM7YUFDM0I7WUFDRCxPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQztnQkFDcEIsSUFBSSxFQUFFLENBQUMsR0FBRyxtQ0FBaUIsRUFBRSxJQUFJLENBQUM7YUFDckM7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLE1BQU07WUFDTixzQkFBWSxDQUFDLEdBQUc7U0FDbkI7S0FDSjtDQUNKLENBQUM7QUFFRixNQUFNLGVBQWUsR0FBRztJQUNwQixFQUFFLEVBQUU7UUFDQSxVQUFVLEVBQUUsRUFBRSxJQUFJLEVBQUUsRUFBRSxPQUFPLEVBQUUsR0FBRyxFQUFDLEVBQUU7S0FDeEM7SUFDRCxJQUFJLEVBQUU7UUFDRixVQUFVLEVBQUU7WUFDUixPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQztnQkFDcEIsSUFBSSxFQUFFLENBQUMsR0FBRyw2QkFBVyxFQUFFLElBQUksQ0FBQzthQUMvQjtTQUNKO0tBQ0o7Q0FDSixDQUFDO0FBRUYsTUFBTSxrQkFBa0IsR0FBRztJQUN2QixFQUFFLEVBQUU7UUFDQSxVQUFVLEVBQUUsRUFBRSxJQUFJLEVBQUUsRUFBRSxPQUFPLEVBQUUsTUFBTSxFQUFFLEVBQUU7S0FDNUM7SUFDRCxJQUFJLEVBQUU7UUFDRixVQUFVLEVBQUU7WUFDUixPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQztnQkFDcEIsSUFBSSxFQUFFLENBQUMsR0FBRyxnQ0FBYyxFQUFFLElBQUksQ0FBQzthQUNsQztZQUNELE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsTUFBTTtnQkFDWixVQUFVLEVBQUU7b0JBQ1IsQ0FBQyxNQUFNLENBQUMsRUFBRTt3QkFDTixPQUFPLEVBQUUsQ0FBQzt3QkFDVixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7b0JBQ0QsQ0FBQyxZQUFZLENBQUMsRUFBRTt3QkFDWixnQkFBZ0IsRUFBRSxDQUFDO3dCQUNuQixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7aUJBQ0o7Z0JBQ0QsUUFBUSxFQUFFLENBQUMsTUFBTSxFQUFFLFlBQVksQ0FBQzthQUNuQztTQUNKO1FBQ0QsUUFBUSxFQUFHLENBQUMsT0FBTyxDQUFDO0tBQ3ZCO0NBQ0osQ0FBQztBQUVGLE1BQU0sbUJBQW1CLEdBQUc7SUFDeEIsRUFBRSxFQUFFO1FBQ0EsVUFBVSxFQUFFLEVBQUUsSUFBSSxFQUFFLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRSxFQUFFO0tBQzdDO0lBQ0QsSUFBSSxFQUFFO1FBQ0YsVUFBVSxFQUFFO1lBQ1IsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUM7Z0JBQ3BCLElBQUksRUFBRSxDQUFDLEdBQUcsaUNBQWUsRUFBRSxJQUFJLENBQUM7YUFDbkM7WUFDRCxPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLE1BQU07Z0JBQ1osVUFBVSxFQUFFO29CQUNSLENBQUMsWUFBWSxDQUFDLEVBQUU7d0JBQ1osZ0JBQWdCLEVBQUUsQ0FBQzt3QkFDbkIsSUFBSSxFQUFjLE1BQU07cUJBQzNCO2lCQUNKO2dCQUNELFFBQVEsRUFBRSxDQUFDLFlBQVksQ0FBQzthQUMzQjtTQUNKO1FBQ0QsUUFBUSxFQUFFO1lBQ04sTUFBTTtZQUNOLE9BQU87WUFDUCxzQkFBWSxDQUFDLEdBQUc7U0FDbkI7S0FDSjtDQUNKLENBQUM7QUFFRixNQUFNLG9CQUFvQixHQUFHLGdDQUFjLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxFQUFFLENBQ25ELENBQUMsYUFBYSxFQUFFLE9BQU8sRUFBRSx1QkFBdUIsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FDaEUsQ0FBQztBQUVGLE1BQU0sa0JBQWtCLEdBQUc7SUFDdkIsRUFBRSxFQUFFO1FBQ0EsVUFBVSxFQUFFLEVBQUUsSUFBSSxFQUFFLEVBQUUsT0FBTyxFQUFFLE1BQU0sRUFBRSxFQUFFO0tBQzVDO0lBQ0QsSUFBSSxFQUFFO1FBQ0YsRUFBRSxFQUFFO1lBQ0EsVUFBVSxFQUFFO2dCQUNSLElBQUksRUFBRSxFQUFFLE9BQU8sRUFBRSxNQUFNLEVBQUU7Z0JBQ3pCLE9BQU8sRUFBRSxFQUFFLE1BQU0sRUFBRSxvQkFBb0IsRUFBRTthQUM1QztTQUNKO1FBQ0QsSUFBSSxFQUFFO1lBQ0YsVUFBVSxFQUFFO2dCQUNSLE9BQU8sRUFBRTtvQkFDTCxJQUFJLEVBQUUsTUFBTTtvQkFDWixJQUFJLEVBQUUsb0JBQW9CO2lCQUM3QjthQUNKO1lBQ0QsUUFBUSxFQUFFO2dCQUNOLHNCQUFZLENBQUMsR0FBRztnQkFDaEIsT0FBTzthQUNWO1NBQ0o7UUFDRCxJQUFJLEVBQUU7WUFDRixHQUFHLEVBQUU7Z0JBQ0QsVUFBVSxFQUFFO29CQUNSLE9BQU8sRUFBRSxFQUFFLE1BQU0sRUFBRSxvQkFBb0IsRUFBRTtpQkFDNUM7YUFDSjtZQUNELFFBQVEsRUFBRTtnQkFDTixNQUFNO2dCQUNOLHNCQUFZLENBQUMsR0FBRztnQkFDaEIsT0FBTzthQUNWO1NBQ0o7S0FDSjtDQUNKLENBQUM7QUFFRixNQUFNLGlCQUFpQixHQUFHO0lBQ3RCLEVBQUUsRUFBRTtRQUNBLFVBQVUsRUFBRSxFQUFFLElBQUksRUFBRSxFQUFFLE9BQU8sRUFBRSxLQUFLLEVBQUUsRUFBRTtLQUMzQztJQUNELElBQUksRUFBRTtRQUNGLFVBQVUsRUFBRTtZQUNSLE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDO2dCQUNwQixJQUFJLEVBQUUsQ0FBQyxHQUFHLCtCQUFhLEVBQUUsSUFBSSxDQUFDO2FBQ2pDO1NBQ0o7S0FDSjtDQUNKLENBQUM7QUFFRixNQUFNLGdCQUFnQixHQUFHO0lBQ3JCLEVBQUUsRUFBRTtRQUNBLFVBQVUsRUFBRSxFQUFFLElBQUksRUFBRSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsRUFBRTtLQUMxQztJQUNELElBQUksRUFBRTtRQUNGLFVBQVUsRUFBRTtZQUNSLE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsTUFBTTtnQkFDWixVQUFVLEVBQUU7b0JBQ1IsQ0FBQyxNQUFNLENBQUMsRUFBRTt3QkFDTixPQUFPLEVBQUUsQ0FBQzt3QkFDVixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7aUJBQ0o7Z0JBQ0QsUUFBUSxFQUFFLENBQUMsTUFBTSxDQUFDO2FBQ3JCO1lBQ0QsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUM7Z0JBQ3BCLElBQUksRUFBRSxDQUFDLEdBQUcsOEJBQVksRUFBRSxJQUFJLENBQUM7YUFDaEM7U0FDSjtRQUNELFFBQVEsRUFBRSxDQUFDLE9BQU8sQ0FBQztLQUN0QjtDQUNKLENBQUM7QUFFRixNQUFNLGtCQUFrQixHQUFHO0lBQ3ZCLEVBQUUsRUFBRTtRQUNBLFVBQVUsRUFBRSxFQUFFLElBQUksRUFBRSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUUsRUFBRTtLQUM3QztJQUNELElBQUksRUFBRTtRQUNGLFVBQVUsRUFBRTtZQUNSLE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDO2dCQUNwQixJQUFJLEVBQUUsQ0FBQyxHQUFHLGdDQUFjLEVBQUUsSUFBSSxDQUFDO2FBQ2xDO1NBQ0o7S0FDSjtDQUNKLENBQUM7QUFFRixNQUFNLGdCQUFnQixHQUFHO0lBQ3JCLEVBQUUsRUFBRTtRQUNBLFVBQVUsRUFBRSxFQUFFLElBQUksRUFBRSxFQUFFLE9BQU8sRUFBRSxJQUFJLEVBQUUsRUFBRTtLQUMxQztJQUNELElBQUksRUFBRTtRQUNGLFVBQVUsRUFBRTtZQUNSLE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsTUFBTTtnQkFDWixVQUFVLEVBQUU7b0JBQ1IsQ0FBQyxNQUFNLENBQUMsRUFBRTt3QkFDTixPQUFPLEVBQUUsQ0FBQzt3QkFDVixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7b0JBQ0QsQ0FBQyxZQUFZLENBQUMsRUFBRTt3QkFDWixnQkFBZ0IsRUFBRSxDQUFDO3dCQUNuQixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7aUJBQ0o7Z0JBQ0QsUUFBUSxFQUFFLENBQUMsTUFBTSxFQUFFLFlBQVksQ0FBQzthQUNuQztZQUNELE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsQ0FBQyxNQUFNLEVBQUUsSUFBSSxDQUFDO2dCQUNwQixJQUFJLEVBQUUsQ0FBQyxHQUFHLDhCQUFZLEVBQUUsSUFBSSxDQUFDO2FBQ2hDO1NBQ0o7UUFDRCxRQUFRLEVBQUUsQ0FBQyxPQUFPLENBQUM7S0FDdEI7Q0FDSixDQUFDO0FBRUYsTUFBTSxpQkFBaUIsR0FBRztJQUN0QixFQUFFLEVBQUU7UUFDQSxVQUFVLEVBQUUsRUFBRSxJQUFJLEVBQUUsRUFBRSxPQUFPLEVBQUUsS0FBSyxFQUFFLEVBQUU7S0FDM0M7SUFDRCxJQUFJLEVBQUU7UUFDRixVQUFVLEVBQUU7WUFDUixPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLE1BQU07Z0JBQ1osSUFBSSxFQUFFLCtCQUFhO2FBQ3RCO1NBQ0o7UUFDRCxRQUFRLEVBQUUsQ0FBQyxPQUFPLENBQUM7S0FDdEI7Q0FDSixDQUFDO0FBRUYsTUFBTSwwQkFBMEIsR0FBRztJQUMvQixFQUFFLEVBQUU7UUFDQSxVQUFVLEVBQUU7WUFDUixJQUFJLEVBQUUsRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFO1NBQzdCO1FBQ0QsR0FBRyxFQUFFO1lBQ0QsVUFBVSxFQUFFO2dCQUNSLE9BQU8sRUFBRSxFQUFFLE1BQU0sRUFBRSxDQUFDLFNBQVMsRUFBRSxPQUFPLENBQUMsRUFBRTthQUM1QztTQUNKO0tBQ0o7SUFDRCxJQUFJLEVBQUU7UUFDRixVQUFVLEVBQUU7WUFDUixPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLE1BQU07Z0JBQ1osSUFBSSxFQUFFLGlDQUFlO2FBQ3hCO1lBQ0QsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxNQUFNO2dCQUNaLFVBQVUsRUFBRTtvQkFDUixDQUFDLFlBQVksQ0FBQyxFQUFFO3dCQUNaLGdCQUFnQixFQUFFLENBQUM7d0JBQ25CLElBQUksRUFBYyxNQUFNO3FCQUMzQjtpQkFDSjtnQkFDRCxRQUFRLEVBQUUsQ0FBQyxZQUFZLENBQUM7YUFDM0I7U0FDSjtRQUNELFFBQVEsRUFBRTtZQUNOLE1BQU07WUFDTixPQUFPO1lBQ1Asc0JBQVksQ0FBQyxHQUFHO1lBQ2hCLE9BQU87U0FDVjtLQUNKO0NBQ0osQ0FBQTtBQUVELE1BQU0sMEJBQTBCLEdBQUc7SUFDL0IsRUFBRSxFQUFFO1FBQ0EsVUFBVSxFQUFFO1lBQ1IsT0FBTyxFQUFFLEVBQUUsT0FBTyxFQUFFLFNBQVMsRUFBQztZQUM5QixJQUFJLEVBQUssRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFO1NBQ2hDO0tBQ0o7SUFDRCxJQUFJLEVBQUU7UUFDRixVQUFVLEVBQUU7WUFDUixPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLE1BQU07Z0JBQ1osSUFBSSxFQUFFLGlDQUFlO2FBQ3hCO1lBQ0QsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxNQUFNO2dCQUNaLFVBQVUsRUFBRTtvQkFDUixDQUFDLE1BQU0sQ0FBQyxFQUFFO3dCQUNOLE9BQU8sRUFBRSxDQUFDO3dCQUNWLElBQUksRUFBYyxNQUFNO3FCQUMzQjtvQkFDRCxDQUFDLFlBQVksQ0FBQyxFQUFFO3dCQUNaLGdCQUFnQixFQUFFLENBQUM7d0JBQ25CLElBQUksRUFBYyxNQUFNO3FCQUMzQjtpQkFDSjtnQkFDRCxRQUFRLEVBQUUsQ0FBQyxNQUFNLEVBQUUsWUFBWSxDQUFDO2FBQ25DO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixNQUFNO1lBQ04sT0FBTztZQUNQLHNCQUFZLENBQUMsR0FBRztZQUNoQixPQUFPO1NBQ1Y7S0FDSjtDQUNKLENBQUE7QUFFRCxNQUFNLHdCQUF3QixHQUFHO0lBQzdCLEVBQUUsRUFBRTtRQUNBLFVBQVUsRUFBRTtZQUNSLE9BQU8sRUFBRSxFQUFFLE9BQU8sRUFBRSxPQUFPLEVBQUM7WUFDNUIsSUFBSSxFQUFLLEVBQUUsT0FBTyxFQUFFLE9BQU8sRUFBRTtTQUNoQztLQUNKO0lBQ0QsSUFBSSxFQUFFO1FBQ0YsVUFBVSxFQUFFO1lBQ1IsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxNQUFNO2dCQUNaLElBQUksRUFBRSxpQ0FBZTthQUN4QjtZQUNELE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsTUFBTTtnQkFDWixVQUFVLEVBQUU7b0JBQ1IsQ0FBQyxZQUFZLENBQUMsRUFBRTt3QkFDWixnQkFBZ0IsRUFBRSxDQUFDO3dCQUNuQixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7aUJBQ0o7Z0JBQ0QsUUFBUSxFQUFFLENBQUMsWUFBWSxDQUFDO2FBQzNCO1NBQ0o7UUFDRCxRQUFRLEVBQUU7WUFDTixPQUFPO1lBQ1Asc0JBQVksQ0FBQyxHQUFHO1lBQ2hCLE9BQU87U0FDVjtLQUNKO0NBQ0osQ0FBQTtBQUVELE1BQU0sbUJBQW1CLEdBQUc7SUFDeEIsMEJBQTBCO0lBQzFCLDBCQUEwQjtJQUMxQix3QkFBd0I7Q0FDM0IsQ0FBQztBQUVGLE1BQU0sb0JBQW9CLEdBQUc7SUFDekIsRUFBRSxFQUFFO1FBQ0EsVUFBVSxFQUFFLEVBQUUsSUFBSSxFQUFFLEVBQUUsT0FBTyxFQUFFLFFBQVEsRUFBRSxFQUFFO0tBQzlDO0lBQ0QsSUFBSSxFQUFFO1FBQ0YsVUFBVSxFQUFFO1lBQ1IsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxDQUFDLE1BQU0sRUFBRSxJQUFJLENBQUM7Z0JBQ3BCLElBQUksRUFBRSxDQUFDLEdBQUcsa0NBQWdCLEVBQUUsSUFBSSxDQUFDO2FBQ3BDO1lBQ0QsT0FBTyxFQUFFO2dCQUNMLElBQUksRUFBRSxNQUFNO2dCQUNaLFVBQVUsRUFBRTtvQkFDUixDQUFDLE1BQU0sQ0FBQyxFQUFFO3dCQUNOLE9BQU8sRUFBRSxDQUFDO3dCQUNWLElBQUksRUFBYyxNQUFNO3FCQUMzQjtvQkFDRCxDQUFDLFlBQVksQ0FBQyxFQUFFO3dCQUNaLGdCQUFnQixFQUFFLENBQUM7d0JBQ25CLElBQUksRUFBYyxNQUFNO3FCQUMzQjtpQkFDSjtnQkFDRCxRQUFRLEVBQUUsQ0FBQyxNQUFNLEVBQUUsWUFBWSxDQUFDO2FBQ25DO1NBQ0o7UUFDRCxRQUFRLEVBQUUsQ0FBQyxPQUFPLENBQUM7S0FDdEI7Q0FDSixDQUFDO0FBRUYsTUFBTSxtQkFBbUIsR0FBRztJQUN4QixFQUFFLEVBQUU7UUFDQSxVQUFVLEVBQUUsRUFBRSxJQUFJLEVBQUUsRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLEVBQUU7S0FDN0M7SUFDRCxJQUFJLEVBQUU7UUFDRixVQUFVLEVBQUU7WUFDUixPQUFPLEVBQUU7Z0JBQ0wsSUFBSSxFQUFFLENBQUMsTUFBTSxFQUFFLElBQUksQ0FBQztnQkFDcEIsSUFBSSxFQUFFLENBQUMsR0FBRyxpQ0FBZSxFQUFFLElBQUksQ0FBQzthQUNuQztZQUNELE9BQU8sRUFBRTtnQkFDTCxJQUFJLEVBQUUsTUFBTTtnQkFDWixVQUFVLEVBQUU7b0JBQ1IsQ0FBQyxNQUFNLENBQUMsRUFBRTt3QkFDTixPQUFPLEVBQUUsQ0FBQzt3QkFDVixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7b0JBQ0QsQ0FBQyxZQUFZLENBQUMsRUFBRTt3QkFDWixnQkFBZ0IsRUFBRSxDQUFDO3dCQUNuQixJQUFJLEVBQWMsTUFBTTtxQkFDM0I7aUJBQ0o7Z0JBQ0QsUUFBUSxFQUFFLENBQUMsTUFBTSxFQUFFLFlBQVksQ0FBQzthQUNuQztTQUNKO1FBQ0QsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO0tBQ3RCO0NBQ0osQ0FBQztBQUVGLE1BQU0sWUFBWSxHQUFHO0lBQ2pCLEtBQUssRUFBRTtRQUNILG9CQUFvQjtRQUNwQixxQkFBcUI7UUFDckIsZUFBZTtRQUNmLGtCQUFrQjtRQUNsQixtQkFBbUI7UUFDbkIsa0JBQWtCO1FBQ2xCLGlCQUFpQjtRQUNqQixnQkFBZ0I7UUFDaEIsa0JBQWtCO1FBQ2xCLGdCQUFnQjtRQUNoQixpQkFBaUI7UUFDakIsR0FBRyxtQkFBbUI7UUFDdEIsb0JBQW9CO1FBQ3BCLG1CQUFtQjtLQUN0QjtDQUNKLENBQUE7QUFFRCxrQkFBZSxZQUFZLENBQUMifQ==